import { QuestionBase } from "src/app/core/components/dynamic-form/models/question-base";

export const searchConfig: QuestionBase[] = [
  {
    key: "company.id",
    label: "Società",
    placeholder: "Seleziona società",
    options: [],
    size: "sm-6",
    required: false,
    controlType: "dropdown",
    type: "",
  },
  {
    key: "id",
    label: "Tipo dipartimento",
    placeholder: "Seleziona tipo dipartimento",
    options: [],
    size: "sm-6",
    required: false,
    controlType: "dropdown",
    type: "",
  },


];
